// @flow
import React, { useEffect, useState } from 'react';

import defaultImgTeam from 'assets/img/logo/placeholder-club.png';
import MatchJoueurResult from 'components/fragments/MatchJoueurResult';
import type { MatchSimple } from 'types/Joueur';
import { getDateFromString, formatFullDate } from 'utils/dateUtils';

type Props = {
  matchs_joues: MatchSimple[]
};

const INITIAL_MATCH_NUMBER = 4;
const GAME_PER_PAGE = 5;

function PlayedGames({ matchs_joues }: Props) {
  const [displayedGames, setDisplayedGames] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const gameNumberToDisplay = INITIAL_MATCH_NUMBER + currentPage * GAME_PER_PAGE;

    const newDisplayedGames = matchs_joues.slice(0, gameNumberToDisplay);

    setDisplayedGames(newDisplayedGames);
  }, [currentPage]);

  const handleShowMore = () => {
    const newCurrentPage = currentPage + 1;
    setCurrentPage(newCurrentPage);
  };

  return (
    <div>
      <h3 className="mb-3 mt-6">Derniers matchs joués</h3>
      {!!displayedGames.length &&
        displayedGames.map((card, index) => {
          return (
            <div key={index}>
              <MatchJoueurResult
                url={card.link}
                adversaire={card.adversaire}
                reception={card.reception}
                score_france={card.france_score}
                score_adversaire={card.adversaire_score}
                logo_france={card.france_logo ? card.france_logo : defaultImgTeam}
                logo_adversaire={card.adversaire_logo ? card.adversaire_logo : defaultImgTeam}
                date_rencontre={formatFullDate(getDateFromString(card.date_rencontre))}
              />
            </div>
          );
        })}

      {!!displayedGames.length && displayedGames.length < matchs_joues.length && (
        <a
          role="button"
          tabIndex={0}
          className="link-chevron link-chevron--block link-chevron--center link-chevron--inline link-blur"
          data-label=""
          onClick={handleShowMore}
        >
          <span>Afficher plus de matchs</span>
          <i className="icon icon-zoom_plus" />
        </a>
      )}
    </div>
  );
}

export default PlayedGames;
